import { render, staticRenderFns } from "./baseSet.vue?vue&type=template&id=6bcf5b1a&scoped=true&"
import script from "./baseSet.vue?vue&type=script&lang=js&"
export * from "./baseSet.vue?vue&type=script&lang=js&"
import style0 from "./baseSet.vue?vue&type=style&index=0&id=6bcf5b1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf5b1a",
  null
  
)

export default component.exports